import AdministracionSalidas from "components-base/pages/administracionsalidas";
const Salidas = () => {
  return (
    <div className="flex w-full flex-col gap-5">
      <AdministracionSalidas />
    </div>
  );
};
export default Salidas;
